import { render, staticRenderFns } from "./ReIdentificacaoDeUsuario.vue?vue&type=template&id=da12e816&"
import script from "./ReIdentificacaoDeUsuario.vue?vue&type=script&lang=js&"
export * from "./ReIdentificacaoDeUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports